import React from 'react';

import { useRespondedOnTimeReportCsv } from 'api';
import { useRespondedOnTimeFilters } from './hooks';
import { MobileReportModal } from '../..';

export const RespondedOnTimeReportMobile: React.FC = () => {
  const filters = useRespondedOnTimeFilters();
  const { mutate: exportCsv } = useRespondedOnTimeReportCsv();

  return <MobileReportModal filters={filters} exportCsv={exportCsv} />;
};
